<h3 class="heading">Bulk Upload</h3>

<!-- Upload -->
<nz-upload
        nzType="drag"
        [nzMultiple]="true"
        [nzLimit]="2"
        nzAction="https://jsonplaceholder.typicode.com/posts/"
        (nzChange)="handleFileUpload($event)"
>
  <p class="ant-upload-drag-icon">
    <i nz-icon nzType="inbox" class="anticon anticon-inbox"></i>
  </p>
  <p class="ant-upload-text">Click or drag file to this area to upload</p>
  <p class="ant-upload-hint">
    Single file & bulk upload supported. Strictly prohibited from uploading internal company data or other confidential data
  </p>
</nz-upload>

<h3 class="heading m-t-20">Records Uploaded (10)</h3>

<!-- Data -->
<nz-table [nzData]="dataSet" [nzShowPagination]="false" [nzScroll]="{ x: '1450px', y: '560px' }">
  <thead>
  <tr>
    <th class="col-has-checkbox">&nbsp;</th>
    <th class="col-has-input">Policy No</th>
    <th class="col-min-width">Client Name</th>
    <th class="col-min-width">Claimant Name</th>
    <th class="col-min-width">Claimant Telephone No</th>
    <th class="col-min-width">Claimant email</th>
    <th class="col-min-width">Intimation Date</th>
    <th class="col-min-width">Intimation Status</th>
    <th class="col-min-width">Event Type</th>
    <th class="col-has-input">Event Date</th>
    <th class="col-has-input">Documents</th>
    <th class="col-min-width">Actions</th>
  </tr>
  </thead>
  <tbody>
  <tr>
    <td class="col-has-checkbox"><label nz-checkbox nzValue="A" [ngModel]="true"></label></td>
    <td class="col-has-input">
      P9200199/JMSP
      <span class="input"><input type="text" nz-input placeholder="Enter Policy #"></span>
    </td>
    <td class="col-min-width">Chris Hemsworth</td>
    <td class="col-min-width">Liam Hemsworth</td>
    <td class="col-min-width">9008902991</td>
    <td class="col-min-width">liam@hemsworth.com</td>
    <td class="col-min-width">10 May 2019</td>
    <td class="col-min-width">Draft</td>
    <td class="col-min-width">Death</td>
    <td class="col-has-input">
      <span class="data">5 May 2019</span>
      <span class="input"><nz-date-picker style="width:110px" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker></span>
    </td>
    <td class="col-has-input">
      <span class="data"><a (click)="docuPanel(1)">Manage</a></span>
      <nz-upload nzAction="https://jsonplaceholder.typicode.com/posts/" [nzFileList]="fileList">
        <button nz-button><i nz-icon nzType="upload" class="anticon anticon-upload"></i><span>Quick Upload</span></button>
      </nz-upload>
    </td>
    <td class="col-min-width"><a>Remove</a></td>
  </tr>
  <tr>
    <td><label nz-checkbox nzValue="A" [ngModel]="true"></label></td>
    <td class="col-has-input">
      P9200199/JMSP/ADDON
      <span class="input"><input type="text" nz-input placeholder="Enter Policy #"></span>
    </td>
    <td>Chris Hemsworth</td>
    <td>Luke Hemsworth</td>
    <td>8119028811</td>
    <td>luke007@hemsworth.com</td>
    <td class="col-min-width">10 May 2019</td>
    <td>Draft</td>
    <td>Death</td>
    <td class="col-has-input">
      <span class="data">5 May 2019</span>
      <span class="input"><nz-date-picker style="width:110px" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker></span>
    </td>
    <td class="col-has-input">
      <span class="data"><a (click)="docuPanel(1)">Manage</a></span>
      <nz-upload nzAction="https://jsonplaceholder.typicode.com/posts/" [nzFileList]="fileListEmpty">
        <button nz-button><i nz-icon nzType="upload" class="anticon anticon-upload"></i><span>Quick Upload</span></button>
      </nz-upload>
    </td>
    <td><a>Remove</a></td>
  </tr>
  <tr>
    <td><label nz-checkbox nzValue="A" [ngModel]="true"></label></td>
    <td class="col-has-input">
      P7800493/PCIU
      <span class="input"><input type="text" nz-input placeholder="Enter Policy #"></span>
    </td>
    <td>Uma Thurman</td>
    <td>Thomas Thurman</td>
    <td>9008902991</td>
    <td>mr.thurman@gmail.com</td>
    <td class="col-min-width">9 May 2019</td>
    <td>Draft</td>
    <td>Death</td>
    <td class="col-has-input">
      <span class="data">28 Apr 2019</span>
      <span class="input"><nz-date-picker style="width:110px" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker></span>
    </td>
    <td class="col-has-input">
      <span class="data"><a (click)="docuPanel(1)">Manage</a></span>
      <nz-upload nzAction="https://jsonplaceholder.typicode.com/posts/" [nzFileList]="fileListEmpty">
        <button nz-button><i nz-icon nzType="upload" class="anticon anticon-upload"></i><span>Quick Upload</span></button>
      </nz-upload>
    </td>
    <td><a>Remove</a></td>
  </tr>
  <tr>
    <td><label nz-checkbox nzValue="A" [ngModel]="true"></label></td>
    <td class="col-has-input">
      P7700675/PCTY
      <span class="input"><input type="text" nz-input placeholder="Enter Policy #"></span>
    </td>
    <td>Chris Pine</td>
    <td>Reeve Pine</td>
    <td>8997160611</td>
    <td>reeve@thepines.net</td>
    <td class="col-min-width">9 May 2019</td>
    <td>Draft</td>
    <td>Death</td>
    <td class="col-has-input">
      <span class="data">5 May 2019</span>
      <span class="input"><nz-date-picker style="width:110px" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker></span>
    </td>
    <td class="col-has-input">
      <span class="data"><a (click)="docuPanel(1)">Manage</a></span>
      <nz-upload nzAction="https://jsonplaceholder.typicode.com/posts/" [nzFileList]="fileListEmpty">
        <button nz-button><i nz-icon nzType="upload" class="anticon anticon-upload"></i><span>Quick Upload</span></button>
      </nz-upload>
    </td>
    <td><a>Remove</a></td>
  </tr>
  <tr>
    <td><label nz-checkbox nzValue="A" [ngModel]="true"></label></td>
    <td class="col-has-input">
      P6070467/PCTX
      <span class="input"><input type="text" nz-input placeholder="Enter Policy #"></span>
    </td>
    <td>Timothy Olyphant</td>
    <td>Thomas Xavier</td>
    <td>9887661092</td>
    <td>tomas.009@megacorp.com</td>
    <td class="col-min-width">8 May 2019</td>
    <td>Draft</td>
    <td>Death</td>
    <td class="col-has-input">
      <span class="data">28 Apr 2019</span>
      <span class="input"><nz-date-picker style="width:110px" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker></span>
    </td>
    <td class="col-has-input">
      <span class="data"><a (click)="docuPanel(1)">Manage</a></span>
      <nz-upload nzAction="https://jsonplaceholder.typicode.com/posts/" [nzFileList]="fileListEmpty">
        <button nz-button><i nz-icon nzType="upload" class="anticon anticon-upload"></i><span>Quick Upload</span></button>
      </nz-upload>
    </td>
    <td><a>Remove</a></td>
  </tr>
  </tbody>
</nz-table>


<!-- Footer -->
<div class="card-summary-data-footer _data-footer-primary">
  <div>
    <!-- Left buttons -->
  </div>
  <div>
    <button nz-button class="m-r-10" [nzType]="'primary'">Process Selected</button>
  </div>
</div>




<!-- DOCUMENTS (DUPLICATE ::: SAME AS THAT IN demo-claims-details component -->
<nz-drawer [nzClosable]="true" [nzWidth]="390" [nzPlacement]="'right'"
           nzTitle="Documents for P9200199"
           [nzVisible]="docuPanelOpen" (nzOnClose)="docuPanel(0)">

  <div *ngIf="docuPanelOpen">


    <div class="upload-block" *ngFor="let u of uploadArray">

      <!-- Selection of Type -->
      <div class="flex flex-horiz-space-bw p-b-10">
        <div>
          <nz-select nzShowSearch  [ngModel]="'0'">
            <nz-option [nzLabel]="'Death Certificate'" [nzValue]="'0'"></nz-option>
            <nz-option [nzLabel]="'Additional Proof'" [nzValue]="'Email'"></nz-option>
          </nz-select>
        </div>
        <span>
              <button nz-button nzType="dashed" nz-popconfirm nzPopconfirmTitle="Remove this section?" nzOkText="Remove" nzCancelText="Cancel" (nzOnConfirm)="removeUploadRow()"><i class="anticon anticon-delete"></i></button>
        </span>
      </div>
      <!-- Upload -->
      <nz-upload
              class="upload-list-inline"
              nzAction="https://jsonplaceholder.typicode.com/posts/"
              nzListType="picture"
              [(nzFileList)]="defaultUploadsList"
      >
        <button nz-button>
          <span><i nz-icon nzType="upload" class="anticon anticon-upload"></i> Upload</span>
        </button>
      </nz-upload>

      <h4 class="d-b m-t-10">Requested Date</h4>
      <nz-date-picker nzShowTime style="width:100%" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>

      <h4 class="d-b m-t-10">Received Date</h4>
      <nz-date-picker nzShowTime style="width:100%" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>

      <div class="flexie-auto-grid">
        <div>
          <h4 class="d-b m-t-10">Visibility</h4>
          <nz-select nzShowSearch  class="w-100-pc" nzPlaceHolder="Select post visibility">
            <nz-option nzLabel="Private (only me)" nzValue="0"></nz-option>
            <nz-option nzLabel="Public (everyone)" nzValue="1"></nz-option>
          </nz-select>
        </div>
        <div>
          <h4 class="d-b m-t-10">Status</h4>
          <nz-select nzShowSearch  class="w-100-pc" [ngModel]="'0'">
              <nz-option [nzLabel]="'Identified'" [nzValue]="'1'"></nz-option>
            <nz-option [nzLabel]="'Waived'" [nzValue]="'0'"></nz-option>
            <nz-option [nzLabel]="'Received'" [nzValue]="'2'"></nz-option>
            <nz-option [nzLabel]="'Fullfilled'" [nzValue]="'3'"></nz-option>
          </nz-select>
        </div>
      </div>


      <h4 class="d-b m-t-10">Comments</h4>
      <textarea class="w-100-pc" rows="2" nz-input placeholder="Comments"></textarea>
    </div>

    <button nz-button (click)="addUploadRow()">Add More</button>

  </div>


</nz-drawer>
